import React from "react";
import { NavLink } from "react-router-dom";
import "../../../components/ui/PageTabs.css";
import "./ApprovalSetupTabs.css";

/**
 * Header shared by Approval Rules (per company) and Approvers (per employee):
 * two tabs plus the order the server uses to pick an approver.
 */
const ApprovalSetupTabs = () => (
  <>
    <nav className="page-tabs" aria-label="Approval setup">
      <NavLink to="/admin/approval-rules">
        <i className="bi bi-buildings me-1"></i>Company rules
      </NavLink>
      <NavLink to="/employee/approvers">
        <i className="bi bi-person-lines-fill me-1"></i>Per-employee approvers
      </NavLink>
    </nav>
    <ol className="approval-setup-order" aria-label="How an approver is chosen">
      <li>
        <strong>Per-employee approvers</strong>
        <span>If the employee has their own list, it is used.</span>
      </li>
      <li>
        <strong>Company rule</strong>
        <span>
          Otherwise, the company's rule for that request: the one for their
          employee type (internal / deployed), else the all-employees rule. A
          sub-company without one uses its parent's.
        </span>
      </li>
      <li>
        <strong>Default</strong>
        <span>Otherwise, their branch manager.</span>
      </li>
    </ol>
    <p className="fs-075 text-slate-500 mb-3">
      HR can always approve. Nobody approves their own request, and a level with
      nobody in it is skipped. When everyone at a level is on leave, the next
      branch manager up covers it.
    </p>
  </>
);

export default ApprovalSetupTabs;
